module.exports = __webpack_public_path__ + "static/logo-46adc98ce200995f0c7405faf07784ee.png";